const PathConstants = {
    admin: "admin-panel",
    login: "admin-panel/login",
    blog: "admin-panel/blogs",
    blogsdetails: "admin-panel/blogsdetails",
    blogsdetailsID: "admin-panel/blogsdetails/:id",
}

export default PathConstants;